import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Journey from '../components/Journey';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import useIsMobile from '../utils/useIsMobile';
import { FiCalendar, FiClock, FiMapPin } from 'react-icons/fi';

const statCards = [
  { icon: FiCalendar, text: 'Nationwide', label: 'Service area',   color: '#3b82f6', bg: '#eff6ff' },
  { icon: FiClock,    text: 'Sales help', label: 'Enrollment',      color: '#10b981', bg: '#ecfdf5' },
  { icon: FiMapPin,   text: 'All USA',    label: 'Service region', color: '#8b5cf6', bg: '#f5f3ff' },
];

const CoverageSection = () => {
  const isMobile = useIsMobile(768);
  return (
    <section style={{ padding: isMobile ? 'clamp(32px, 6vw, 48px) var(--cc-px)' : 'clamp(64px, 7vw, 100px) var(--cc-px)', background: '#f8f9fc', fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>
      <div className="cc-container" style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1.4fr',
        gap: 'clamp(24px, 4vw, 56px)',
        alignItems: 'center',
      }}>
        {/* Left — content + stat cards */}
        <div>
          <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#2563eb', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 12 }}>Coverage</span>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 4.5rem)', fontWeight: 900, color: '#0f172a', margin: '0 0 16px', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
            Serving All Over the USA
          </h2>
          <p style={{ color: '#64748b', fontSize: 'clamp(0.9rem, 1.5vw, 1rem)', lineHeight: 1.8, margin: '0 0 14px' }}>
            From coast to coast — we help homes and businesses compare and order Internet, Cable TV, Wi-Fi, and Wireless from licensed providers.
          </p>
          <p style={{ color: '#94a3b8', fontSize: 'clamp(0.82rem, 1.4vw, 0.9rem)', lineHeight: 1.75, margin: '0 0 28px' }}>
            Service availability depends on your specific address and third-party provider coverage networks. Contact us to confirm what's available at your location.
          </p>

          {/* Stat cards - responsive: 1 col on xs, 3 on sm+ */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(90px, 100%), 1fr))', gap: 12 }}>
            {statCards.map(({ icon: Icon, text, label, color, bg }, i) => (
              <div key={i} style={{
                background: '#fff', borderRadius: 16, padding: '18px 12px',
                border: '1.5px solid #e8edf5', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                textAlign: 'center',
              }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px' }}>
                  <Icon style={{ width: 18, height: 18, color }} />
                </div>
                <div style={{ fontSize: '1.1rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2, marginBottom: 5, letterSpacing: '-0.02em' }}>{text}</div>
                <div style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: 600 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right — map */}
        <div style={{
          borderRadius: 22, overflow: 'hidden',
          border: '1.5px solid #e2e8f0',
          boxShadow: '0 8px 48px rgba(0,0,0,0.08)',
          height: isMobile ? 'clamp(220px, 50vw, 280px)' : 'clamp(360px, 40vw, 520px)',
        }}>
          <iframe
            title="USA Coverage Map"
            src="https://www.google.com/maps?q=United+States&output=embed&z=4"
            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <Services />
      <CoverageSection />
      <Journey />
      <FAQ />
      <CTA />
    </main>
  );
};

export default Home;
